import { api } from '@marketplace-web/core-api/core-api-client-data'

import {
  GetCatalogFacetedCategoriesArgs,
  GetCatalogFiltersArgs,
  GetCatalogItemsArgs,
  GetCatalogSearchedFiltersArgs,
} from '../types/dtos/api-arg'
import {
  BrandResp,
  GetCatalogFacetedCategoriesResp,
  GetCatalogFiltersFacetsResp,
  GetCatalogFiltersResp,
  GetCatalogItemsResp,
  GetCatalogSearchedFiltersResp,
  GetSessionDefaultsResp,
} from '../types/dtos/api-resp'
import {
  getCatalogFacetedCategoriesArgsToParams,
  getCatalogFiltersArgsToParams,
  getCatalogItemsArgsToParams,
  getCatalogSearchedFiltersArgsToParams,
} from '../transformers/api-transform'

const moneyObjectHeader = {
  'X-Money-Object': 'true',
}

export const getBrandById = (brandId: number) => api.get<BrandResp>(`/brands/${brandId}`)

export const getSessionDefaults = () =>
  api.get<GetSessionDefaultsResp>('/configurations/session_defaults')

export const getCatalogFacetedCategories = (args: GetCatalogFacetedCategoriesArgs) =>
  api.get<GetCatalogFacetedCategoriesResp>('/catalog/faceted_categories', {
    params: getCatalogFacetedCategoriesArgsToParams(args),
  })

export const getCatalogFiltersFacets = (args: GetCatalogFiltersArgs) =>
  api.get<GetCatalogFiltersFacetsResp>('/catalog/filters/facets', {
    params: getCatalogFiltersArgsToParams(args),
  })

export const getCatalogFilters = (args: GetCatalogFiltersArgs) =>
  api.get<GetCatalogFiltersResp>('/catalog/filters', {
    params: getCatalogFiltersArgsToParams(args),
  })

export const getCatalogItems = (args: GetCatalogItemsArgs) =>
  api.get<GetCatalogItemsResp>('/catalog/items', {
    params: {
      ...getCatalogItemsArgsToParams(args),
      search_by_image_uuid: args.searchByImageUuid,
    },
    headers: moneyObjectHeader,
  })

export const getCatalogSearchedFilters = (args: GetCatalogSearchedFiltersArgs) =>
  api.get<GetCatalogSearchedFiltersResp>('/catalog/filters/search', {
    params: getCatalogSearchedFiltersArgsToParams(args),
  })
